<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" id="upart-1">
<div class="heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">REVELATION ONE SHADOWCASTER</h1>
</div>
</div>
</div>
</div>
<div class="text" id="upart-1-text">
<div class="alignment-block alignment-block-align-left inset-block">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>“I see nobody on the road,” said Alice.</i></p>
</div>
<p class="implicit-break"></p>
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>“I only wish I had such eyes to see Nobody!</i></p>
<p class="alignment-block-content alignment-block-content-left"><i>And at such a distance too!”</i></p>
</div>
</div>
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<p class="blockquote-attribution blockquote-position-last"><span class="case-upper">—LEWIS CARROLL</span></p>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// upart001.vue?4cca1d7a